module.exports = __webpack_public_path__ + "img/add_cover.507572a4.png";